import { axiosRubyClient } from '@/util/axios/axiosClient';

export interface Skill {
  id: number;
  name: string;
  display_name_en?: string;
  display_name_es?: string;
  description_en?: string;
  description_es?: string;
  requirements?: string[];
  certificate?: {
    type: string;
    label: string;
  } | null;
  requires_certificate?: boolean;
}

export interface SkillRequestV2 {
  id: number;
  skill_id: number;
  worker_id: number;
  work_experience_completed: boolean;
  assessment_passed: boolean;
  uniform_photo_uploaded: boolean;
  certificate_photo_uploaded: boolean;
  work_experience_completed_at: string | null;
  assessment_passed_at: string | null;
  uniform_photo_uploaded_at: string | null;
  certificate_photo_uploaded_at: string | null;
  accepted_at: string | null;
  rejected_at: string | null;
  status: string;
  completion_percentage: number;
  created_at: string;
  updated_at: string;
  skill: Skill;
}

export interface WorkerUniform {
  id: number;
  worker_id: number;
  uniform_id: number | null;
  image_key: string | null;
  image_url: string | null; // Full S3 URL to the image
  status: 'pending' | 'accepted' | 'rejected';
  comment: string | null; // Required for rejected, optional for accepted
  created_at: string; // ISO 8601 format
  updated_at: string; // ISO 8601 format
  worker?: {
    id: number;
    user: {
      id: number;
      email: string;
      phone_number: string | null;
      first_name: string;
      last_name: string;
    };
    city: string | null;
    state: string | null;
    zip: string | null;
    onboarding_status: string | null;
    background_status: string | null;
  };
  skill_request_v2?: SkillRequestV2[]; // Array of skill requests (can be multiple)
}

export interface ListUniformsResponse {
  success: boolean;
  uniforms: WorkerUniform[];
}

export interface AcceptUniformResponse {
  success: boolean;
  uniform: WorkerUniform;
}

export interface RejectUniformResponse {
  success: boolean;
  uniform: WorkerUniform;
}

// Fetch pending uniforms
export const fetchPendingUniforms = async (): Promise<ListUniformsResponse> => {
  const response = await axiosRubyClient.get('/api/admin/worker_uniforms', {
    params: { status: 'pending' },
  });
  return response.data;
};

// Accept a uniform
export const acceptUniform = async (
  id: number,
  comment?: string,
): Promise<AcceptUniformResponse> => {
  const response = await axiosRubyClient.post(
    `/api/admin/worker_uniforms/${id}/accept`,
    { comment },
  );
  return response.data;
};

// Reject a uniform
export const rejectUniform = async (
  id: number,
  comment: string,
): Promise<RejectUniformResponse> => {
  if (!comment || comment.trim() === '') {
    throw new Error('Comment is required for rejection');
  }
  const response = await axiosRubyClient.post(
    `/api/admin/worker_uniforms/${id}/reject`,
    { comment },
  );
  return response.data;
};
